import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

import { Button, ButtonIcon } from 'rmwc/Button';
import SerializeForm from 'form-serialize'
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Grid, GridCell } from 'rmwc/Grid';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { Link } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel';
import GoogleTagManager from '../util/GoogleTagManager'
import ReactGA from 'react-ga';

import StatusMessage from '../util/StatusMessage'


class PostPayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      errorMsg: '',
      
    }
  }

  componentDidMount() {

    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-124053817-1');
    ReactGA.pageview('/post_payment');
    ReactPixel.init('299200161137777')
      ReactPixel.pageView('/post_payment');
      ReactPixel.track('Purchase', {
      value: 'PurchaseWeb',
    });

  }

  render(){
    return (
      <Grid>
        <GridCell span="12">
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
                <Typography use="headline5">THANK YOU FOR Registration/ Purchase!</Typography>
                <div> <GoogleTagManager gtmId='GTM-T3VT4PJ'/></div>
                <Grid className="opportunity-list-item">
                  <GridCell span="12">
                    For CENTA TPO/ TQ registrations, Please click <Link to="/portal/app/my_registrations"> here </Link> to view the details
                  </GridCell>
                  <GridCell span="12">
                    For learning module purchases, Please click <Link to="/portal/app/purchase/orders"> here </Link> to view the details
                  </GridCell>
                </Grid>                 
            </Card>
          </form>  
        </GridCell>
      </Grid>  

      )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostPayment); 


// WEBPACK FOOTER //
// ./src/views/PostPayment.jsx